import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { IEntityRoleDTO } from '../../../../../api/events.dao';
import { IUserOperatorDTO, OperatorRole } from '../../../../../api/operators.dao';
import { IOperatorDetailsDTO } from '../../../../../api/rooms.dao';
import MultiSelectWithRoleHeader from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-header';
import { MultiSelectWithRoleList } from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-list';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import { OperatorsListButton } from './operators-list-button';
import { cancelText } from '../../../../../constants/common-labels.constants';

interface IProps {
    operatorsListToAdd: IUserOperatorDTO[];
    operators: IOperatorDetailsDTO[];
    operatorRoles: IEntityRoleDTO[];
    intl: IntlShape;
    initOperatorsData: (query?: string) => Promise<void>;
    addOperatorsToTheMeeting: (operatopsList: IUserOperatorDTO[]) => void;
    setOperatorRole: (email: string, role: OperatorRole) => void;
    removeOperator: (email: string) => void;
}

const OperatorsListButtonWrapper = (props: IProps) => {
    const {
        operatorsListToAdd,
        operators,
        initOperatorsData,
        addOperatorsToTheMeeting,
        operatorRoles,
        intl,
        setOperatorRole,
        removeOperator,
    } = props;

    return operators.length
        ? <OperatorsListButton
            addOperatorsToTheMeeting={addOperatorsToTheMeeting}
            operatorsListToAdd={operatorsListToAdd}
            initOperatorsData={initOperatorsData}
            operatorRoles={operatorRoles}
            setOperatorRole={setOperatorRole}
            removeOperator={removeOperator}
            operators={operators}
            intl={intl}
        />
        : <MultiSelectButton
            searchWithDebounce
            items={operatorsListToAdd}
            value={[]}
            onChange={addOperatorsToTheMeeting}
            onClick={initOperatorsData}
            filterHandler={initOperatorsData}
            className='default-button--no-border add-attendee-btn visible-on-hover'
            popoverClassName='multi-select-with-role event_form__items-section m-bottom-0px'
            text={<FormattedMessage
                id='oe.operators.add'
                description='Button text'
                defaultMessage='{prefix} Add Operators'
                values={{prefix: '+'}}
            />}
            keyProperty='email'
            nameProperty='fullName'
            applyButtonText={<FormattedMessage
                id='oe.common.add'
                description='Button text'
                defaultMessage='{prefix} Add Operators'
            />}
            resetButtonText={cancelText()}
            renderHeader={MultiSelectWithRoleHeader}
            renderSelectList={rest =>
                <MultiSelectWithRoleList
                    entityRoleKey='operatorRole'
                    intlRoleKey='operators.roleOptions'
                    entityRolesList={operatorRoles}
                    intl={intl}
                    {...rest}
                />
            }
        />;
};

export {
    OperatorsListButtonWrapper
};